import { fetchApi } from '@/config/axiosSetting.ts';
import { GetDamagedUserInformationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedUserInformation/getDamagedUserInformationQuery.type';
import { PersonalInformationOwnerResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';

export const getDamagedUserInformationQueryFunction = (
  id: number,
  params?: GetDamagedUserInformationQueryParamsType,
): Promise<PersonalInformationOwnerResponseType> =>
  fetchApi({
    url: `/property/reports/${id}/accident_users/damaged/user_information/owner/`,
    params,
  });
